import { Controller } from '@hotwired/stimulus'
import { Popover } from 'bootstrap'

// Connects to data-controller="popover"
export default class extends Controller {
  static targets = ['trigger']
  static values = {
    content: String,
    title: String,
    placement: { type: String, default: 'top' },
    trigger: { type: String, default: 'hover focus' }
  }

  connect () {
    this.popover = new Popover(this.element, {
      content: this.contentValue,
      title: this.titleValue,
      placement: this.placementValue,
      trigger: this.triggerValue,
      customClass: 'popover-custom',
      html: true,
      sanitize: false
    })
  }

  disconnect () {
    if (this.popover) {
      this.popover.dispose()
    }
  }
}
